export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.directive('animate-on-scroll', {
    // Required for SSR — return empty object so prerender doesn't crash
    getSSRProps() {
      return {};
    },
    mounted(el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      el.style.transition = 'all 1s cubic-bezier(0.16, 1, 0.3, 1)';
      
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
            observer.unobserve(el);
          }
        });
      }, { threshold: 0.1 });
      
      observer.observe(el);
    }
  });
});
